import { FC } from "react";
import { IProductPrice } from "types/product";
import { renderLabelWholeSale } from "utils/text";

interface IWholesaleInfo {
  priceList: IProductPrice[];
  unit: string;
}
const WholesaleInfo: FC<IWholesaleInfo> = ({ priceList, unit }) => {
  return (
    <div className="flex flex-col">
      {priceList
        .sort((a, b) => (a.minQuantity || 0) - (b.minQuantity || 0))
        .map((item) => {
          return (
            <div
              className="flex-row flex gap-4 h-[48px] self-start items-center bg-[#F8FEEEE8] mb-3 px-4"
              key={item.price}
            >
              <div>
                {renderLabelWholeSale(item.minQuantity, item.maxQuantity, unit)}
              </div>
              <div>ราคา {item.price} บาท</div>
            </div>
          );
        })}
    </div>
  );
};

export default WholesaleInfo;
